import {UserShortInfo} from "./PayoutLimitsResponse";
import {WithdrawTransaction} from "./TransactionsResponse";
import {User} from "../User";

export interface ConfirmationStatus {
    id: number,
    name: string
}

export interface ConfirmationType {
    id: number,
    name: string
}

export interface ConfirmationFiltersResponse {
    data: {
        statuses: ConfirmationStatus[],
        types: ConfirmationType[]
    }
}

export interface Confirmation {
    id: number,
    created_by: User,
    changed_by: User | null,
    status: string,
    type: string,
    object: WithdrawTransaction | UserShortInfo,
    date: string,
    updated: string,
    payload: object
}

export interface ConfirmationsResponse {
    data: Confirmation[],
    pages: {
        total: number,
        current: number
    }
    count: number,
}

export enum ConfirmationT{
    WITHDRAW = 'Withdraw request',
    USER = 'New user'
}
